import { AppAction, Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { AssignmentDto, AssignmentType } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { FEATURE_FLAG } from '../../apis/eols-features-api/eols-features-api.constants';
import { GetAssignmentInfoProps } from '../../models/assignment-types-shared.models';
import { getBooleanFromGroupFeatureFlagWithFallbackToGlobal } from '../../utilities/featureFlag.utilities';
import { ApplicationNavigateHandlerMapProps, AssignmentOverviewHandlersMap, AssignmentTypeStrategy, CoursePlanClickSettings } from '../model';
import { adaptiveQuizPerformanceReportClick, adaptiveQuizTitleClick, navigateExternal } from '../utils/common.utils';

const handlerMap = (props: AssignmentOverviewHandlersMap) => {
  const { featureFlagsGrouped, courseSectionId, assignment } = props;
  const isAuthessEnabled = getBooleanFromGroupFeatureFlagWithFallbackToGlobal(
    featureFlagsGrouped,
    FEATURE_FLAG.IS_EAQ_AUTHESS_APP_LINK_ENABLED, // Stu role flag
    courseSectionId
  );
  const isAuthess = Boolean(isAuthessEnabled && assignment && assignment.assignmentType === AssignmentType.AUTHESS);
  return isAuthess ? Application.AUTHESS : Application.EAQ;
};
export const adaptiveQuiz: AssignmentTypeStrategy = {
  coursePlanTitleClick: adaptiveQuizTitleClick,
  coursePlanClickSettings: (props: CoursePlanClickSettings) => {
    const { assignment, defArgs, sharedAppLinkParams } = props;
    const { featureFlagsGrouped, courseSectionId, navigateToApp } = defArgs.props;
    const action = assignment ? AppAction.ASSIGNMENT_EDIT : AppAction.ASSIGNMENT_CREATE;
    const isEnableEAQAssignmentManagementApp = featureFlagsGrouped && courseSectionId ? getBooleanFromGroupFeatureFlagWithFallbackToGlobal(
      featureFlagsGrouped,
      FEATURE_FLAG.ENABLE_EAQ_ASSIGNMENT_MANAGEMENT_APP_CREATE_EDIT,
      courseSectionId
    ) : false;
    navigateToApp({
      app: isEnableEAQAssignmentManagementApp ? Application.ASSIGNMENT_MANAGEMENT : Application.EAQ,
      action,
      body: sharedAppLinkParams
    });
  },
  coursePlanPerformanceReportClick: adaptiveQuizPerformanceReportClick,
  assignmentOverviewTitleClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  assignmentOverviewPerformanceReportClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  navigateToAppForAssignmentPerformanceHandlerMap: handlerMap,
  navigateToAppHandlerMap: handlerMap,
  assignmentInfoHandler: (props: GetAssignmentInfoProps): Promise<AssignmentDto> => Promise.resolve(props.newAssignment)
};
